import { render, staticRenderFns } from "./TopicSelection.vue?vue&type=template&id=3c23d969"
import script from "./TopicSelection.vue?vue&type=script&lang=js"
export * from "./TopicSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports